import React, { useEffect, useRef } from 'react';
import prefersReducedMotion, { hasFinePointer } from './prefersReducedMotion';

/** A soft red spotlight trailing the mouse across the arena (desktop pointers only). */
export default function CursorGlow() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (!hasFinePointer() || prefersReducedMotion()) {
      el.style.display = 'none';
      return undefined;
    }
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 3;
    let tx = x;
    let ty = y;
    let raf = 0;
    const onMove = (e) => { tx = e.clientX; ty = e.clientY; el.style.opacity = '1'; };
    const onLeave = () => { el.style.opacity = '0'; };
    const tick = () => {
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      el.style.transform = `translate3d(${x - 300}px, ${y - 300}px, 0)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    window.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerleave', onLeave);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerleave', onLeave);
    };
  }, []);
  return <div ref={ref} aria-hidden="true" className="pnp-cursor-glow" />;
}
